import React, { FC, useEffect, useState } from 'react'
import cn from '@/utils/cn'
import { Box, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useGetUserProfileQuery } from '@/modules/user/services/userService'
import { UserTypes } from '@/types/typeUser'
import { useGetUnitsHomeMapMutation } from '@/modules/maps/services/homeMapService'
import { UnitSearchReq } from '@/modules/devices-list/types/newUnitsType'
import { useGetDtpFormDataQuery } from '@/modules/add-new-dtp/components/dtpService'
import { useAppSelector } from '@/hooks'
import { filterSystemSelector } from '@/store/filterSystemsSlise'
import MapDTP, { UnitDtp } from '@/components/Organisms/Map/MapDTP'
import Header from '@/modules/devices-list/components/Header/Header'
import { Cluster } from '@/modules/maps/types/unitsMapType'
const center = [47.2313, 39.7233]

interface Props {
  setNewCoords: (coords: number[]) => void
  newCoords: number[]
  isHomePage?: boolean
  allIncidents?: boolean
  centerCoords?: number[]
  disabled?: boolean
}

const MapDTPProvider: FC<Props> = ({
  isHomePage,
  setNewCoords,
  newCoords,
  allIncidents,
  centerCoords,
  disabled,
}) => {
  const [getDataUnits, { data: locationsRes, isLoading }] =
    useGetUnitsHomeMapMutation()
  const [locations, setLocations] = React.useState([])
  const [clusters, setClusters] = React.useState([])
  const {
    additionalFilter,
    startDate,
    endDate,
    deviceStateFilter,
    favoriteId,
    searchValue,
    isSearch,
  } = useAppSelector(filterSystemSelector)
  const initialStartDate = allIncidents ? '2000-01-01T00:00:00.000Z' : ''
  const reduxStartDate = startDate ? startDate.toISOString() : ''
  const getData = async () => {
    const sValue = !searchValue.trim().length ? '' : searchValue
    const usersSearchData: Omit<UnitSearchReq, 'page'> = {
      value: sValue,
      deviceTypeFilter: [15],
      deviceStateFilter: deviceStateFilter,
      favoriteId: favoriteId,
      startDate: initialStartDate || reduxStartDate || '',
      endDate: endDate ? endDate.toISOString() : '',
      additionalFilter: additionalFilter,
      includeTotals: isHomePage,
      bounds: {
        minLat: 46.66894809391073,
        minLng: 38.22366621093747,
        maxLat: 47.78771143732232,
        maxLng: 41.22293378906246,
      },
      includeAccidents: !!sValue,
    }
    try {
      const res = await getDataUnits(usersSearchData).unwrap()
      if (res.success) {
        const allData = res?.data?.data || []
        const dtp = allData.filter((item) => item.typeId === 15)
        const clusters = allData.filter(
          (item) => item.typeId === 16 || item.typeId === 17
        )
        // @ts-ignore
        setLocations(dtp)
        // @ts-ignore
        setClusters(clusters)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getDataWithShowDots = async (showDots: boolean, bounds: any) => {
    const sValue = !searchValue.trim().length ? '' : searchValue
    const usersSearchData: Omit<UnitSearchReq, 'page'> = {
      value: sValue,
      deviceTypeFilter: [15],
      deviceStateFilter: deviceStateFilter,
      favoriteId: favoriteId,
      startDate: startDate ? startDate.toISOString() : '',
      endDate: endDate ? endDate.toISOString() : '',
      additionalFilter: additionalFilter,
      includeAccidents: showDots || !!sValue,
      includeTotals: isHomePage,
      bounds: {
        minLat: bounds[0][0],
        minLng: bounds[0][1],
        maxLat: bounds[1][0],
        maxLng: bounds[1][1],
      },
    }
    try {
      const res = await getDataUnits(usersSearchData).unwrap()
      if (res.success) {
        const allData = res?.data?.data || []
        const dtp = allData.filter((item) => item.typeId === 15)
        const clusters = allData.filter(
          (item) => item.typeId === 16 || item.typeId === 17
        )
        // @ts-ignore
        setLocations(dtp)
        // @ts-ignore
        setClusters(clusters)
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getData().then()
  }, [])

  useEffect(() => {
    getData().then()
  }, [startDate, endDate, deviceStateFilter, additionalFilter, isSearch])

  return (
    <>
      {/*{isLoading ? (*/}
      {/*  <CircularProgress />*/}
      {/*) : (*/}
      <>
        <Box className={'home-map'}>
          {isHomePage && <Header isMap={true} />}
          <MapDTP
            isHomePage={isHomePage}
            center={centerCoords ? centerCoords : center}
            // center={center}
            dataUnits={locations}
            clusters={clusters}
            setNewCoords={setNewCoords}
            newCoords={newCoords}
            draggable={!!isHomePage && !disabled}
            disabled={disabled}
            onGetDataWithShowDots={getDataWithShowDots}
          />
        </Box>
      </>
      {/*)}*/}
    </>
  )
}

export default MapDTPProvider
